import i18n from 'i18n'
import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'

import { ALERTS } from 'app/@common/constants'

// Las opciones vienen por ajax; el value (</>/ns/sn) es identidad enviada al backend.
// Solo se traduce el display (por label EN, ya que value colisiona entre tipos de alerta).
const COMP_KEY = {
    'My web is cheaper than others': 'alerts:comparison.webCheaper',
    'My web is more expensive than others': 'alerts:comparison.webMoreExpensive',
    'My hotel is cheaper than competitor': 'alerts:comparison.hotelCheaper',
    'My hotel is more expensive than competitor': 'alerts:comparison.hotelMoreExpensive',
    'Main No Avail vs Competitor Avail': 'alerts:comparison.mainNoAvailCompAvail',
    'Main Avail vs Competitor No Avail': 'alerts:comparison.mainAvailCompNoAvail',
}

export default function SelectComparison({ ...props }) {
    const myProps = {
        urlAjax: `${ALERTS.COMPARISON_LIST}/${props.alertType || ''}`,
        label: i18n.t('alerts:columns.comparison'),
        isClearable: true, firstSelect: false, isMulti: true,
        icon: { icon: 'calculator-alt' },
        formatOptionLabel: opt => i18n.t(COMP_KEY[opt?.label] || '', { defaultValue: opt?.label }),
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}